import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Button, Flex, Modal } from 'antd'
import { PartnerReferralWhitelistItem } from 'Modules'

export type PartnerActionType = 'deactivate' | 'delete'

interface PartnerActionModalProps {
  open: boolean
  type: PartnerActionType
  record: PartnerReferralWhitelistItem | null
  loading: boolean
  onConfirm: () => void
  onClose: () => void
}

const CONFIG: Record<
  PartnerActionType,
  { title: string; subtitle: string; confirmLabel: string; description: string }
> = {
  deactivate: {
    title: 'Deactivate Partner',
    subtitle: 'This wallet will stop earning partner referral rewards',
    confirmLabel: 'Deactivate',
    description:
      'This wallet will no longer be counted as a partner referral and will fall back to the normal user referral rate.',
  },
  delete: {
    title: 'Remove Wallet',
    subtitle: 'This action cannot be undone',
    confirmLabel: 'Remove',
    description: 'This wallet address will be removed from the partner whitelist.',
  },
}

export const PartnerActionModal = ({
  open,
  type,
  record,
  loading,
  onConfirm,
  onClose,
}: PartnerActionModalProps) => {
  const config = CONFIG[type]

  return (
    <Modal
      open={open}
      title={
        <Flex gap={8} align="start">
          <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: 20, marginTop: 2 }} />
          <Flex vertical>
            <div>{config.title}</div>
            <div style={{ fontSize: 12, color: '#6a7282', fontWeight: 400 }}>{config.subtitle}</div>
          </Flex>
        </Flex>
      }
      onCancel={onClose}
      closable={!loading}
      maskClosable={!loading}
      centered
      destroyOnClose
      footer={() => (
        <>
          <Button disabled={loading} onClick={onClose}>
            Cancel
          </Button>
          <Button
            color={type === 'delete' ? 'danger' : 'default'}
            variant="solid"
            loading={loading}
            onClick={onConfirm}
          >
            {config.confirmLabel}
          </Button>
        </>
      )}
    >
      <p style={{ marginTop: 0 }}>{config.description}</p>
      {record && (
        <Flex vertical gap={4} style={{ fontSize: 13 }}>
          <div>
            <span style={{ color: '#6a7282' }}>Wallet Address: </span>
            <span style={{ wordBreak: 'break-all' }}>{record.walletAddress}</span>
          </div>
          {type === 'deactivate' && record.email && (
            <div>
              <span style={{ color: '#6a7282' }}>Email: </span>
              <span>{record.email}</span>
            </div>
          )}
        </Flex>
      )}
    </Modal>
  )
}
